// Collection links remain usable without JavaScript and with modifier keys.
let revision = 0;
let motion;
const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
const pages = new Map();
const lifetime = 120000;

function keyFor(url) {
  const key = new URL(url, location.href);
  key.hash = '';
  key.searchParams.delete('preview_theme_id');
  return key.href;
}

function loadPage(url, priority = 'auto') {
  const key = keyFor(url);
  const cached = pages.get(key);
  if (cached && Date.now() - cached.time < lifetime) return cached.promise;
  const entry = { time: Date.now() };
  entry.promise = fetch(url, { priority }).then(response => {
    if (!response.ok) throw new Error('Collection request failed');
    return response.text();
  }).catch(error => {
    if (pages.get(key) === entry) pages.delete(key);
    throw error;
  });
  if (pages.size >= 12) pages.delete(pages.keys().next().value);
  pages.set(key, entry);
  return entry.promise;
}

// Seed the current collection, then warm only the small material navigation.
pages.set(keyFor(location.href), {
  time: Date.now(), promise: Promise.resolve(document.documentElement.outerHTML)
});
function warmMaterials() {
  if (navigator.connection?.saveData) return;
  document.querySelectorAll('.tonus-material-nav a').forEach(link => {
    if (new URL(link.href).origin === location.origin) loadPage(link.href, 'low').catch(() => {});
  });
}
if (document.readyState === 'complete') warmMaterials();
else window.addEventListener('load', warmMaterials, { once: true });
for (const eventName of ['pointerover', 'focusin', 'touchstart']) {
  document.addEventListener(eventName, event => {
    const link = event.target.closest('.tonus-material-nav a');
    if (link && new URL(link.href).origin === location.origin) loadPage(link.href).catch(() => {});
  }, { passive: true });
}

async function navigate(url, push = true) {
  const nav = document.querySelector('.tonus-material-nav');
  const current = document.querySelector('collection-component');
  if (!nav || !current) return location.assign(url);
  const ticket = ++revision;
  motion?.cancel();
  nav.setAttribute('aria-busy', 'true');
  current.setAttribute('aria-busy', 'true');
  try {
    const doc = new DOMParser().parseFromString(await loadPage(url, 'high'), 'text/html');
    const next = doc.querySelector('collection-component');
    const nextNav = doc.querySelector('.tonus-material-nav');
    if (!next || !nextNav) throw new Error('Collection missing');
    if (ticket !== revision) return;
    if (!reducedMotion.matches) {
      motion = current.animate([
        { opacity: 1, transform: 'translateX(0)' },
        { opacity: 0, transform: 'translateX(48px)' }
      ], { duration: 120, easing: 'cubic-bezier(.4,0,1,1)', fill: 'forwards' });
      await motion.finished;
    }
    if (ticket !== revision) return;
    current.replaceWith(next);
    motion?.cancel();
    const selected = nextNav.querySelector('[aria-current="page"]')?.getAttribute('href');
    nav.querySelectorAll('a').forEach(link => {
      if (link.getAttribute('href') === selected) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
    const heading = document.querySelector('.tn-catalog-intro h1');
    const nextHeading = doc.querySelector('.tn-catalog-intro h1');
    if (heading && nextHeading) heading.replaceChildren(...nextHeading.childNodes);
    document.title = doc.title;
    if (push) history.pushState({}, '', url);
    const canonical = document.querySelector('link[rel="canonical"]');
    const nextCanonical = doc.querySelector('link[rel="canonical"]');
    if (canonical && nextCanonical) canonical.href = nextCanonical.href;
    if (!reducedMotion.matches) {
      motion = next.animate([
        { opacity: 0, transform: 'translateX(-40px)' },
        { opacity: 1, transform: 'translateX(0)' }
      ], { duration: 280, easing: 'cubic-bezier(.22,1,.36,1)' });
    }
    const status = document.querySelector('[data-material-status]');
    if (status) status.textContent = nextNav.querySelector('[aria-current="page"]')?.textContent.trim() || '';
  } catch (error) {
    if (ticket === revision && error.name !== 'AbortError') location.assign(url);
  } finally {
    if (ticket === revision) {
      nav.removeAttribute('aria-busy');
      document.querySelector('collection-component')?.removeAttribute('aria-busy');
    }
  }
}

document.addEventListener('click', event => {
  const link = event.target.closest('.tonus-material-nav a');
  if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
  const url = new URL(link.href);
  if (url.origin !== location.origin) return;
  event.preventDefault();
  if (url.href !== location.href || link.closest('nav').hasAttribute('aria-busy')) navigate(url.href);
});
window.addEventListener('popstate', () => {
  if (document.querySelector('.tonus-material-nav')) navigate(location.href, false);
});
